/**
 * @file Sidebar.js
 * @description Manages all sidebar interactions (nav, theme, controls).
 * (REFACTORED: Integrated Router Navigation)
 */

export class Sidebar {
    constructor(services) {
        this.stateManager = services.state;
        this.eventBus = services.eventBus;
        this.themeManager = services.theme;
        this.dom = {
            navItems: document.querySelectorAll('.nav-item'),
            aegisOsBtn: document.getElementById('aegis-os-btn'),
            blueprintBtn: document.getElementById('blueprint-btn'),
        };
    }

    init() {
        // 1. Initialize Nav Items
        this.dom.navItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const sectionId = item.dataset.section;
                
                // Only navigate if not already active to prevent redundant history entries
                if (!item.classList.contains('active')) {
                    this.stateManager.navigate([sectionId]);
                }
            });
        });

        // 2. Initialize Theme Buttons (Direct Calls)
        if (this.dom.aegisOsBtn) {
            this.dom.aegisOsBtn.addEventListener('click', () =>
                this.stateManager.setTheme('aegis')
            );
        }
        if (this.dom.blueprintBtn) {
            this.dom.blueprintBtn.addEventListener('click', () =>
                this.stateManager.setTheme('blueprint')
            );
        }
    }
}
